import React from 'react'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'
import Text from '@navent-jobs/ui-kit/components/text'
import { Modal } from '@navent-jobs/ui-kit/components/modal'
import { DeleteImage, ModalContent, CustomButton, ButtonContent, TitleWrapper } from './mixins'
import { SiteIds, SITE_ID } from '../../../../../constants'
import deleteImageBm from '../../../../../assets/images/curriculum/eliminar.svg'
import deleteImageZj from '../../../../../assets/images/curriculum/eliminar-zj.svg'

const deleteImage = SITE_ID === SiteIds.ZJAR ? deleteImageZj : deleteImageBm

interface EliminarModalProps {
  activeModal: string
  name: string
  title: string
  isLoading: boolean
  confirmHandler: () => void
  cancelHandler: () => void
}

const ModalFooter = ({ isLoading, confirmHandler, cancelHandler }) => {
  const { t } = useTranslation()

  return (
    <ButtonContent>
      <CustomButton buttonoptions={{ size: 'medium', type: 'link', block: true }} onClick={cancelHandler}>
        {t('account.deleteAccount.confirmModal.ctaCancel')}
      </CustomButton>
      <CustomButton
        disabled={isLoading}
        buttonoptions={{ variant: 'primary', size: 'medium', block: true }}
        onClick={confirmHandler}
        isLoading={isLoading}
      >
        {t('account.deleteAccount.confirmModal.ctaConfirm')}
      </CustomButton>
    </ButtonContent>
  )
}

const ConfirmationModal = ({
  activeModal,
  name,
  title,
  isLoading,
  confirmHandler,
  cancelHandler,
}: EliminarModalProps) => {
  const visible = activeModal === name

  return (
    <Modal
      width={575}
      visible={visible}
      onClose={cancelHandler}
      footer={<ModalFooter isLoading={isLoading} confirmHandler={confirmHandler} cancelHandler={cancelHandler} />}
    >
      <ModalContent>
        <DeleteImage src={deleteImage} />
        <TitleWrapper>
          <Text size="lg" fontWeight="semibold" variant="secondary">
            {title}
          </Text>
        </TitleWrapper>
      </ModalContent>
    </Modal>
  )
}

const states = ({ modalStore }) => ({
  activeModal: modalStore.activeModal,
})

export default connect(states)(ConfirmationModal)
